// extracted by mini-css-extract-plugin
module.exports = {"pot_types":"PotTypeSelection_pot_types__P0uSu","div-clip":"PotTypeSelection_div-clip__5XmeT","pot_types__container":"PotTypeSelection_pot_types__container__b1d4u"};